module.exports = __webpack_public_path__ + "img/SingleLineText.5060455c.svg";